import { render, staticRenderFns } from "./CertificateApplys.vue?vue&type=template&id=2be1266e&scoped=true&"
import script from "./CertificateApplys.vue?vue&type=script&lang=js&"
export * from "./CertificateApplys.vue?vue&type=script&lang=js&"
import style0 from "./CertificateApplys.vue?vue&type=style&index=0&id=2be1266e&scoped=true&lang=css&"
import style1 from "./CertificateApplys.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1266e",
  null
  
)

export default component.exports